/* global jQuery */
import isAdmin from '../../../helpers/isAdmin';

( ( $ ) => {
	const initializeBlock = ( $block ) => {
		if ( ! $block.length || isAdmin ) {
			return;
		}

	};

	// Initialize each block on page load (front end).
	$( document ).ready( () => {
		
	} );

	// Initialize dynamic block preview (editor).
	if ( window.acf ) {
		window.acf.addAction(
			'render_block_preview/type=homepage-features',
			initializeBlock
		);
	}
} )( jQuery );
